const SIZE_ALIASES = {
  sm: "small",
  md: "medium",
  lg: "large",
};

export default function Button({
  as: Component = "button",
  variant = "primary",
  size = "medium",
  className = "",
  loading = false,
  disabled = false,
  children,
  ...props
}) {
  const normalizedSize = SIZE_ALIASES[size] || size;
  const isNativeButton = Component === "button";
  const isDisabled = disabled || loading;

  return (
    <Component
      className={`ds-button ds-button--${variant} ds-button--${normalizedSize}${className ? ` ${className}` : ""}`}
      {...(isNativeButton
        ? { disabled: isDisabled }
        : { "aria-disabled": isDisabled || undefined })}
      aria-busy={loading || undefined}
      {...props}
    >
      {loading ? <span className="ds-button__spinner" aria-hidden="true" /> : null}
      {children}
    </Component>
  );
}
